"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shell_component_1 = require("./shell/shell.component");
var authentication_guard_1 = require("./authentication/authentication.guard");
/**
 * Provides helper methods to create routes.
 */
var Route = /** @class */ (function () {
    function Route() {
    }
    /**
     * Creates routes using the shell component and authentication.
     * @param routes The routes to add.
     * @return {Routes} The new routes using shell as the base.
     */
    Route.withShell = function (routes) {
        return [{
                path: '',
                component: shell_component_1.ShellComponent,
                children: routes,
                canActivate: [authentication_guard_1.AuthenticationGuard],
                // Reuse ShellComponent instance when navigating between child views
                data: { reuse: true }
            }];
    };
    return Route;
}());
exports.Route = Route;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91dGUuc2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJvdXRlLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSwyREFBeUQ7QUFDekQsOEVBQTRFO0FBRTVFOztHQUVHO0FBQ0g7SUFBQTtJQWtCQSxDQUFDO0lBaEJHOzs7O09BSUc7SUFDSSxlQUFTLEdBQWhCLFVBQWlCLE1BQWM7UUFDM0IsT0FBTyxDQUFDO2dCQUNKLElBQUksRUFBRSxFQUFFO2dCQUNSLFNBQVMsRUFBRSxnQ0FBYztnQkFDekIsUUFBUSxFQUFFLE1BQU07Z0JBQ2hCLFdBQVcsRUFBRSxDQUFDLDBDQUFtQixDQUFDO2dCQUNsQyxvRUFBb0U7Z0JBQ3BFLElBQUksRUFBRSxFQUFDLEtBQUssRUFBRSxJQUFJLEVBQUM7YUFDdEIsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUVMLFlBQUM7QUFBRCxDQUFDLEFBbEJELElBa0JDO0FBbEJZLHNCQUFLIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/core/route.service.ts
// module id = 178
// module chunks = 0